export const PLAYER_OPTIONS = {
    width: "100%",
    height: "100%",
    playerVars: {
        controls: 1,
        autoplay: 1,
        hl: "pl",
        modestbranding: 1,
    },
};

export default PLAYER_OPTIONS;
